import { forwardRef } from 'react';

interface Props {
  aiGenerated?: boolean;
  className?: boolean;
}
export function withAiStyles<P>(
  WrappedComponent: React.ComponentType<React.PropsWithChildren<P>>,
) {
  const WithAiBackground = forwardRef<unknown, P & Props>((props, ref) => {
    const { aiGenerated, className } = props;

    return (
      <WrappedComponent
        ref={ref as React.Ref<unknown>}
        className={`${className ?? ''}${aiGenerated ? ' with-ai-background' : ''}`}
        {...(props as P & object)}
      />
    );
  });

  const name =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';

  WithAiBackground.displayName = `aiBackgrounded(${name})`;

  return WithAiBackground;
}
